import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { SPEED_BACKEND_BASE_URL } from './config';

if (typeof window !== 'undefined') {
  const originalFetch = window.fetch.bind(window);
  window.fetch = (input: RequestInfo | URL, init?: RequestInit) => {
    const apiBaseUrl = process.env.REACT_APP_API_BASE_URL || '/api';
    
    // URL 정규화 함수
    const normalizeUrl = (url: string): string => {
      // /api/api/ 중복 제거 (모든 경우)
      url = url.replace(/\/api\/api+/g, '/api');
      
      // localhost:3600을 /api로 변환
      if (url.startsWith('http://localhost:3600')) {
        const path = url.replace('http://localhost:3600', '');
        return path.startsWith('/') ? `${apiBaseUrl}${path}` : `${apiBaseUrl}/${path}`;
      }
      
      // wallet.voltron.app도 /api로 변환
      if (url.includes('wallet.voltron.app')) {
        const path = url.replace(/https?:\/\/wallet\.voltron\.app/, '');
        return path.startsWith('/') ? `${apiBaseUrl}${path}` : `${apiBaseUrl}/${path}`;
      }
      
      return url;
    };
    
    if (typeof input === 'string') {
      const normalized = normalizeUrl(input);
      return originalFetch(normalized, init);
    }

    if (input instanceof URL) {
      const normalized = normalizeUrl(input.href);
      const nextUrl = normalized.startsWith('http') 
        ? new URL(normalized)
        : new URL(normalized, window.location.origin);
      return originalFetch(nextUrl, init);
    }

    return originalFetch(input, init);
  };
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
